import { Controller } from "stimulus"
import { default as TomSelect } from "tom-select"

const EMAIL_REGEX = /[A-Z0-9._%+\-]+@[A-Z0-9.\-]+\.[A-Z]{2,}/gi

export default class extends Controller {
  static targets = ['select']

  connect() {
    this.addCss()

    if (this.selectTarget.tomselect) {
      this.selectTarget.tomselect.destroy()
    }

    this.tom = new TomSelect(this.selectTarget, {
      create: (input) => {
        const matches = [...input.matchAll(EMAIL_REGEX)].map(m => m[0].toLowerCase())
        if (matches.length > 0) {
          return { value: matches[0], text: matches[0] }
        }
        return false
      },
      createOnBlur: true,
      plugins: ['remove_button'],
      maxItems: null,
      closeAfterSelect: false,
      placeholder: "name@example.com",
      onChange: () => this.updateTrigger(),
    })

    this.tom.control_input.addEventListener('paste', (e) => this.onPaste(e))
    this.updateTrigger()
  }

  addCss() {
    if (document.getElementById("tom-select-css")) return

    const css = document.createElement("link")
    css.rel = "stylesheet"
    css.href = "https://cdn.jsdelivr.net/npm/tom-select@2.2.2/dist/css/tom-select.min.css"
    css.id = "tom-select-css"
    document.head.appendChild(css)
  }

  disconnect() {
    if (this.hasSelectTarget && this.selectTarget.tomselect) {
      this.selectTarget.tomselect.destroy()
    }
  }

  onPaste(e) {
    const text = e.clipboardData.getData('text')
    const emails = [...new Set([...text.matchAll(EMAIL_REGEX)].map(m => m[0].toLowerCase()))]
    if (emails.length === 0) return

    e.preventDefault()
    emails.forEach(email => {
      if (!this.tom.options[email]) {
        this.tom.addOption({ value: email, text: email })
      }
      this.tom.addItem(email, true)
    })
    this.tom.refreshItems()
    this.updateTrigger()
  }

  clearTokens() {
    this.tom.clear()
    this.updateTrigger()
    this.apply()
  }

  apply() {
    this.element.hidden = true
    const form = this.element.closest('form')
    if (form) form.requestSubmit()
  }

  updateTrigger() {
    const count = this.tom.items.length
    const searchFilterEl = this.element.closest('[data-controller~="search-filter"]')
    if (!searchFilterEl) return
    const trigger = searchFilterEl.querySelector('[data-target~="search-filter.trigger"]')
    if (!trigger) return

    const selectedClass = 'bg-purple-600 text-white'
    const deselectedClass = 'bg-white text-black'

    if (count === 0) {
      trigger.textContent = 'All'
      selectedClass.split(' ').forEach(c => trigger.classList.remove(c))
      deselectedClass.split(' ').forEach(c => trigger.classList.add(c))
    } else {
      trigger.textContent = count === 1 ? this.tom.items[0] : `${count} selected`
      deselectedClass.split(' ').forEach(c => trigger.classList.remove(c))
      selectedClass.split(' ').forEach(c => trigger.classList.add(c))
    }
  }
}
